import SimpleWorkspaceCard from '../../../../components/SimpleWorkspaceCard';
import { Text } from '../../../../components/typography';
import TextWithIcon from '../../../../components/typography/TextWithIcon';
import { useWorkspace } from '../../../../providers/WorkspaceProvider';
import { chartTitle } from '../../../../utilities/reports';
import styles from './CustomReportHeader.module.scss';
import { customColors } from '../../../../utilities';
import { Chip } from '@mui/material';
import { useMemo } from 'react';
import { useCurrentUser } from '../../../../providers/UserProvider';

export default function CustomReportHeader({ options, models, total = 0 }) {
  const { user } = useCurrentUser();
  const header = useMemo(
    () => chartTitle(options, models, undefined, user?.timeSetting),
    [options, models, user?.timeSetting],
  );
  const { title, description, days, filterString } = header || {};
  const { workspaces } = options || {};
  const { allWorkspaces } = useWorkspace();

  // options.target is absent on attachments saved before this field
  // existed, so undefined here just means "no target set" — not an error.
  const targetValue = Number(options?.target);
  const hasTarget = Number.isFinite(targetValue);

  const selectedWorkspaces = workspaces?.map((w) =>
    allWorkspaces.find((a) => a.id === w?.id || a?.id === w),
  );

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div>
          <div className={styles.flexRow}>
            <Text weight="semiBold" size="md-lg" noMargin>
              {title}
            </Text>
          </div>
          <Text size="sm" noMargin>
            {description}
          </Text>
        </div>
        <div>
          {options?.type === 'PIVOT' ? (
            <></>
          ) : (
            <Text
              textAlign="right"
              noMargin
              weight="semiBold"
            >{`Total: ${total}${total === 100 ? '+' : ''}`}</Text>
          )}
          {hasTarget && options?.type !== 'PIVOT' && (
            <Text textAlign="right" noMargin color="secondary" size="sm">
              {`Target: ${targetValue}`}
            </Text>
          )}
          <TextWithIcon
            leftIcon="timer"
            color="secondary"
            noMargin
            weight="semiBold"
            size="sm"
            iconProps={{ fontSize: '1.2rem' }}
          >
            {`${days} ${days > 1 ? 'days' : 'day'}`}
          </TextWithIcon>
        </div>
      </div>

      <div className={styles.workspaces}>
        {selectedWorkspaces?.length ? (
          selectedWorkspaces?.map((w) => (
            <div>
              <SimpleWorkspaceCard workspace={w} size="sm" weight="regular" />
            </div>
          ))
        ) : (
          <TextWithIcon
            iconProps={{ fontSize: '1rem', color: customColors.GREEN }}
            leftIcon="check_circle"
            size="sm"
          >
            All Workspaces
          </TextWithIcon>
        )}
      </div>
      <div className={styles.filters}>
        {filterString && <Chip label={filterString} />}
      </div>
    </div>
  );
}
